export const STANDALONE_ONBOARDING_IMAGE =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/c9cef1477752962506e04d5bebe0f27d-1750769516780/onboarding_standalone.jpg';
